import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Title from "../../../../components/Title/component";
import LayoutFactory from "../../../../components/LayoutFactory/component";
import { fetchTrendingVideos } from "../../../../actions/VideoTrending/dispatcher";
import { TRENDING_SWIMLANE_LAYOUT } from "../../../../components/LayoutFactory/constants";
import { MLDRIVEN_ITEMS_ALGORITHM_TYPE } from "../../../FlexibleLandingPage/components/MLDrivenItemsWidget/constants";
import DetailDiscoveryPlaceholder from "../Discovery/components/DetailDiscoveryPlaceholder/component";

const TRENDING_LIMIT = 5;

const VideoTrending = () => {
    const path = useSelector((state) => state.app.path);
    const trendingItemsInStore = useSelector(
        (state) => state.video.trendingClips.items
    );
    const isLoaded = useSelector((state) => state.video.trendingClips.isLoaded);
    const dispatch = useDispatch();
    const featureAttributionData = {
        instance: MLDRIVEN_ITEMS_ALGORITHM_TYPE.TRENDING,
    };

    useEffect(() => {
        dispatch(
            fetchTrendingVideos(TRENDING_LIMIT, path, TRENDING_SWIMLANE_LAYOUT)
        );
    }, []);

    if (!isLoaded) {
        return (
            <div className="horizontal trending">
                <DetailDiscoveryPlaceholder numLoadingCards={TRENDING_LIMIT} />
            </div>
        );
    }

    if (!trendingItemsInStore?.length) return;

    return (
        <div className="horizontal trending">
            <Title level="h2">Trending Videos</Title>
            <LayoutFactory
                layout={TRENDING_SWIMLANE_LAYOUT}
                items={trendingItemsInStore}
                featureAttributionData={featureAttributionData}
            />
        </div>
    );
};

export default VideoTrending;
